// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

/** Accepts any value; change values are intentionally untyped raw snapshot JSON. */
const unknownValue = (_value: unknown): _value is unknown => true;

const isAgentVersionFieldChange = objectOf({
  field: string,
  previous_value: unknownValue,
  current_value: unknownValue,
});

export const isGenerativeAiAgentIdVersionDiffResult = objectOf({
  version: number,
  created_at: number,
  created_by: maybe(string, true),
  changes: arrayOf(isAgentVersionFieldChange),
});
